// extracted by mini-css-extract-plugin
module.exports = {"gauge":"e_Dwb","ring":"e_Ewb","ringText":"e_Fwb","ringVal":"e_Gwb","ringMax":"e_Hwb","label":"e_Iwb","labelClamp":"e_Jwb","sub":"e_Kwb"};